import { render, staticRenderFns } from "./pages.meta.vue?vue&type=template&id=062b189c"
import script from "./pages.meta.vue?vue&type=script&lang=js"
export * from "./pages.meta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports